import { AgentKnowledge } from "../AgentKnowledge";
import Section from "./Section";

import type { ConfigSection } from "../ConfigSectionHelp";
import type { Agent } from "@/shared/types";

/* The agent's default knowledge bases. Not a switch: knowledge is on wherever a base
   is linked, and the links apply at once, outside the draft. */
export default function KnowledgeSection({ agent, onHelp }: {
  agent: Agent;
  onHelp: (section: ConfigSection) => void;
}) {
  return (
    <Section section="kb" onHelp={onHelp}>
      <AgentKnowledge agentId={agent.id} />
    </Section>
  );
}
